import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

import {
  DEPLOYMENT_SETTING_CREATE_GITHUB_EXPORT_SETTING_BEGIN,
  DEPLOYMENT_SETTING_CREATE_GITHUB_EXPORT_SETTING_SUCCESS,
  DEPLOYMENT_SETTING_CREATE_GITHUB_EXPORT_SETTING_FAILURE,
} from './constants';

export function createGithubExportSetting(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: DEPLOYMENT_SETTING_CREATE_GITHUB_EXPORT_SETTING_BEGIN,
    });

    const { projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const body = args.body;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/code-export/github/save-setting`,
        body,
        header,
      );
      const { success, data, message } = response.data;
      if (success) {
        dispatch({
          type: DEPLOYMENT_SETTING_CREATE_GITHUB_EXPORT_SETTING_SUCCESS,
          data: data,
        });
        toast.success('Github Setting created successfully!');
      } else {
        const error = message || 'Failed to create GitHub export setting';
        dispatch({
          type: DEPLOYMENT_SETTING_CREATE_GITHUB_EXPORT_SETTING_FAILURE,
          data: { error: error },
        });
        toast.error(`Error: ${error}`);
        throw new Error(error);
      }
    } catch (error) {
      dispatch({
        type: DEPLOYMENT_SETTING_CREATE_GITHUB_EXPORT_SETTING_FAILURE,
        data: { error: error.message },
      });
      toast.error(`Error: ${error.message}`);
    }
  };
}

// Reducer
export function reducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT_SETTING_CREATE_GITHUB_EXPORT_SETTING_BEGIN:
      return {
        ...state,
        createGithubExportSettingPending: true,
        createGithubExportSettingError: null,
      };

    case DEPLOYMENT_SETTING_CREATE_GITHUB_EXPORT_SETTING_SUCCESS:
      return {
        ...state,
        createGithubExportSettingPending: false,
        createGithubExportSettingError: null,
        githubExportList: [...state.githubExportList, action.data],
      };

    case DEPLOYMENT_SETTING_CREATE_GITHUB_EXPORT_SETTING_FAILURE:
      return {
        ...state,
        createGithubExportSettingPending: false,
        createGithubExportSettingError: action.data.error,
      };

    default:
      return state;
  }
}
